import { Grid } from "@material-ui/core";
import { shimmerLoaderStyle } from "./style";

const ShimmerLoader = ({ count = 1, height = '50', width = 12 }) => {
    const classes = shimmerLoaderStyle();

    return (
        <Grid container spacing={1} >
            {Array.from({ length: count }, (_, i) => (
                <Grid xs={width} item key={i} ><div className={classes.shine} style={{ height: `${height}px` }}></div></Grid>))
            }
        </Grid>
    );
}
export default ShimmerLoader;